import React, { useState } from "react";
import SuccessMessageContext, { SuccessMessageState } from 'contexts/SuccessMessageContext'
import { defaultSuccessMessageState } from 'contexts/SuccessMessageContext'
import uuidv4 from 'uuid/v4'

function SuccessMessageProvider({ children }) {
  const [successMessageState, setSuccessMessageState] = useState<
    SuccessMessageState
  >(defaultSuccessMessageState);

  function showSuccessMessage(successMessage: string) {
      setSuccessMessageState({
        ...successMessageState,
        successMessage,
        successMessageShown: true,
        successMessageId: uuidv4()
      });        
  }

  function hideSuccessMessage() {
      setSuccessMessageState({
        ...successMessageState,
        successMessageShown: false
      });
  }

  return (
    <SuccessMessageContext.Provider
      value={{
        ...successMessageState,
        showSuccessMessage,
        hideSuccessMessage
      }}
    >
      {children}
    </SuccessMessageContext.Provider>
  );
}

export default SuccessMessageProvider;
